"use client";

import { useCustomerAccounts } from "@/hooks/useCustomerAccounts";
import { useLocaleRedirect } from "@/hooks/useLocaleRedirect";

/**
 * Sends a shopper home from the customer-account pages (login, signup,
 * password reset, account) of a store that takes orders without accounts.
 * Every header hides the way in; this closes a bookmarked or typed URL.
 *
 * Waits for the settings to come from the API on this visit: acting on the
 * persisted value would bounce a shopper off a store that has since turned
 * accounts back on. Renders nothing, so the page is untouched otherwise.
 */
export function GuestOrderingRedirect() {
  const { guestOrdering, isLoaded } = useCustomerAccounts();
  useLocaleRedirect(isLoaded && guestOrdering, "/");
  return null;
}
